/* eslint-disable no-restricted-globals */
import '../css/main.css';

import lazyLoadModule from './utils/loaders/moduleLoader.js';

lazyLoadModule('alpineComponents', 100);

// Lazy images — custom IO observer (modules/lazysizes.js), not the npm lazysizes package
const selector = 'img[loading="lazy"], iframe[loading="lazy"], source[data-srcset]';
const lazyImageEls = document.querySelectorAll(selector);
if (lazyImageEls.length > 0 && 'loading' in HTMLImageElement.prototype) {
  lazyLoadModule('lazysizes', 100, { els: lazyImageEls, selector });
}

if (import.meta.hot) {
  import.meta.hot.accept();
}
